import { useModalForm } from '@/shared/hooks/useModalForm';
import { inspectionService } from '../../services/inspection.service'

export interface CancelFormData {
  reason: string;
  additionalInfo?: string | undefined;
}

interface UseCancelInspectionModalProps {
  inspectionItemId?: string;
  onClose: () => void;
  onSuccess: () => void;
}

export function useCancelInspectionModal({
  onClose,
  onSuccess,
  inspectionItemId
}: UseCancelInspectionModalProps) {
  const { form, isSubmitting, handleFormSubmit } = useModalForm<CancelFormData>({
    onSubmit: async (values) => {
      if (!inspectionItemId) return;
      await inspectionService.cancelInspectionItem(inspectionItemId, values);
    },
    onClose,
    onSuccess,
    successMessage: 'Inspeção cancelada com sucesso!',
    errorMessage: 'Erro ao cancelar inspeção',
  });

  return {
    form,
    isSubmitting,
    handleFormSubmit,
  };
}
